import React from 'react';

const AUTH_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/aman-erp-logo.png`;

/**
 * AMAN ERP Markenlogo (Login, Registrierung, Auth-Seiten).
 */
const AuthBrandLogo = ({ className = '', size = 72 }) => (
  <img
    src={AUTH_LOGO_SRC}
    alt="AMAN ERP"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className={`auth-brand-logo__img ${className}`.trim()}
  />
);

export default AuthBrandLogo;
